import React, { useState } from 'react'

import { Container, NavigateButton } from './styles'

import IProps from './props'

import { buttonLabels } from './utils'

const Navigation = ({ onNavigate }: IProps) => {
  const [activeButton, setActiveButton] = useState('Especialidade')

  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    const { name } = evt.currentTarget
    setActiveButton(name)
    onNavigate(name)
  }

  return (
    <Container>
      {buttonLabels.map((buttonLabel) => (
        <NavigateButton
          name={buttonLabel}
          key={buttonLabel}
          className={activeButton === buttonLabel ? 'active' : ''}
          onClick={handleClick}
        >
          {buttonLabel}
        </NavigateButton>
      ))}
    </Container>
  )
}

export default Navigation
